import React from "react";

export default function SheetIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="M21 21.082V6.832L14.25.082H6a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3Zm-6.75-16.5a2.25 2.25 0 0 0 2.25 2.25h3v6.75h-15v-10.5a1.5 1.5 0 0 1 1.5-1.5h8.25v3Zm-9.75 13.5v-3h3v3h-3Zm0 1.5h3v3H6a1.5 1.5 0 0 1-1.5-1.5v-1.5Zm4.5 3v-3h10.5v1.5a1.5 1.5 0 0 1-1.5 1.5H9Zm10.5-4.5H9v-3h10.5v3Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .082h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
